<template>
  <div v-if="(displayGlobalAlerts?.length ?? 0) > 0" class="w-full relative z-[9999]">
    <!-- GLOBAL ALERT START -->
    <GlobalAlert
      v-for="(item, itemIndex) in displayGlobalAlerts"
      :key="itemIndex"
      :type="item?.fields?.type?.value"
      :content="item?.fields?.content?.value"
      :visibility="item?.fields?.visibility?.value"
    ></GlobalAlert>
    <!-- GLOBAL ALERT END -->
  </div>
  <header class="top-0 sticky header-container lg:border-b border-solid border-light-grey bg-racq-true-white">
    <div class="forms-header w-full">
      <div class="header-logo">
        <sc-link class="flex" :field="fields.logoLink ? fields.logoLink : {}">
          <sc-image :media="fields.racqLogo" />
        </sc-link>
      </div>
      <h1 class="form-title"><sc-text :field="pageTitle" /></h1>
      <div class="hidden ml-auto mr-[18px] lg:block xl:hidden w-[300px]">
        <FormStepperBar v-if="formStore.showStepper" />
      </div>
      <div class="help-content">
        <sc-link :field="fields.helpContentLink ? fields.helpContentLink : {}">
          <sc-image :media="fields.helpLogo" />
        </sc-link>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import {
  Text as ScText,
  Image as ScImage,
  Link as ScLink,
  ComponentFields,
  ComponentRendering,
  Field,
} from '@sitecore-jss/sitecore-jss-vue';
import FormStepperBar from '@/components/FormStepperBar/FormStepperBar.vue';
import { useFormStore } from '@/store';
import GlobalAlert from '@/components/GlobalAlert/GlobalAlert.vue';
import { GlobalAlertsVisibility } from '@/enums/global-alerts.enum';

const formStore = useFormStore();

const props = withDefaults(
  defineProps<{
    fields: ComponentFields;
    rendering: ComponentRendering;
    pageTitle?: string;
    globalAlerts?: any[];
  }>(),
  { pageTitle: '' }
);

const displayGlobalAlerts = props.globalAlerts?.filter(
  (x: any) =>
    x.fields?.visibility?.value === GlobalAlertsVisibility.All ||
    x.fields?.visibility?.value === GlobalAlertsVisibility.Quotes
);

const pageTitle = computed(() => {
  const pageTitle = props.fields?.pageTitle as Field<any>;
  return pageTitle?.value ? pageTitle : { value: props.pageTitle };
});

onMounted(() => {
  const pageTitleField = pageTitle.value;
  formStore.setPageTitle(pageTitleField.value);
});
</script>
